/**
 * @module experience/shop/shared-cart
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';
import { RouterModule } from '@angular/router';

import { AccountLevelServiceComponent } from '@experience/shop/cart/shared-cart-modules/account-level-service/account-level-service.component';
import { AddLineComponent } from '@experience/shop/cart/shared-cart-modules/add-line/add-line.component';
import { CartAccessoriesComponent } from '@experience/shop/cart/shared-cart-modules/cart-accessories/cart-accessories.component';
import { CpsPlanServicesPageComponent } from '@experience/shop/cart/shared-cart-modules/cps-plan-services-page/cps-plan-services-page.component';
import { DeviceDetailsComponent } from '@experience/shop/cart/shared-cart-modules/device-details/device-details.component';
import { ExchangeItemDetailsComponent } from '@experience/shop/cart/shared-cart-modules/exchange-item-details/exchange-item-details.component';
import { GuestCheckoutModalComponent } from '@experience/shop/cart/shared-cart-modules/guest-checkout-modal/guest-checkout-modal.component';
import { LearnMoreModalComponent } from '@experience/shop/cart/shared-cart-modules/learn-more-modal/learn-more-modal.component';

import { LineDetailsComponent } from '@experience/shop/cart/shared-cart-modules/line-details/line-details.component';
import { PromoCodeComponent } from '@experience/shop/cart/shared-cart-modules/promo-code/promo-code.component';
import { ReturnItemDetailsComponent } from '@experience/shop/cart/shared-cart-modules/return-item-details/return-item-details.component';
import { RunCreditModalComponent } from '@experience/shop/cart/shared-cart-modules/run-credit-modal/run-credit-modal.component';
import { CpsDueTodayPricingComponent } from '@experience/shop/cart/shared-cart-modules/cps-due-today-pricing/cps-due-today-pricing.component';
import { PricingPanelComponent } from '@experience/shop/cart/shared-cart-modules/pricing-panel/pricing-panel.component';
import { CartLandingComponent } from '@experience/shop/cart/components/cart-landing.component';
import { RefundPriceDetailsComponent } from '@experience/shop/cart/shared-cart-modules/refund-price-details/refund-price-details.component';
import { ReturnExchangePricePanelComponent } from '@experience/shop/cart/shared-cart-modules/return-exchange-price-panel/return-exchange-price-panel.component';
import { CartReviewService } from '@experience/shop/cart/services/cart-review.service';
import { AddressValidateService } from '@support/cart-support/services/address-validate-service';
import { SetFocusService } from '@support/shared/widgets/services/set-focus.service';
import { AccountSetupService } from '@experience/shop/cart/modules/account-setup/services/account-setup.service';
import { RemorseService } from '@support/cart-support/services/remorse.service';
import { ReturnPaymentService } from '@experience/shop/return-payment/services/return-payment.service';
import { SupportOrderPaymentService } from '@support/payment-options/services/support-payment.service';
import { CartNotEmptyModalService } from '@support/shared/services/cart-not-empty-modal.service';
import { OrderSummaryComponent } from './order-summary/order-summary.component';
import { PricingDetailComponent } from '@experience/shop/cart/shared-cart-modules/pricing-detail/pricing-detail.component';
import { RemoveCartItemModalComponent } from '@experience/shop/cart/shared-cart-modules/remove-cart-item-modal/remove-cart-item-modal.component';
import { cartAuthenticationGuard } from '@experience/shop/cart/services/cart-authentication-guard.service';
import { ProductSelectorModule } from '@experience/shop/product-selector/product-selector.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetsModule,
    RouterModule,
    ProductSelectorModule,
  ],
  exports: [
    AccountLevelServiceComponent,
    AddLineComponent,
    CartAccessoriesComponent,
    CpsPlanServicesPageComponent,
    DeviceDetailsComponent,
    ExchangeItemDetailsComponent,
    GuestCheckoutModalComponent,
    LearnMoreModalComponent,
    LineDetailsComponent,
    PromoCodeComponent,
    ReturnItemDetailsComponent,
    RunCreditModalComponent,
    CpsDueTodayPricingComponent,
    PricingPanelComponent,
    CartLandingComponent,
    ReturnExchangePricePanelComponent,
    RefundPriceDetailsComponent,
    PricingDetailComponent,
    OrderSummaryComponent,
    RemoveCartItemModalComponent,
  ],
  declarations: [
    AccountLevelServiceComponent,
    AddLineComponent,
    CartAccessoriesComponent,
    CpsPlanServicesPageComponent,
    DeviceDetailsComponent,
    ExchangeItemDetailsComponent,
    GuestCheckoutModalComponent,
    LearnMoreModalComponent,
    LineDetailsComponent,
    PromoCodeComponent,
    ReturnItemDetailsComponent,
    RunCreditModalComponent,
    CpsDueTodayPricingComponent,
    PricingPanelComponent,
    CartLandingComponent,
    ReturnExchangePricePanelComponent,
    RefundPriceDetailsComponent,
    OrderSummaryComponent,
    PricingDetailComponent,
    RemoveCartItemModalComponent,
  ],
  providers: [
    CartReviewService,
    AddressValidateService,
    SetFocusService,
    AccountSetupService,
    RemorseService,
    ReturnPaymentService,
    SupportOrderPaymentService,
    CartNotEmptyModalService,
    cartAuthenticationGuard,
  ],
})
export class SharedCartModule {}
